<!-- 停检单 SQM -->
<template>
  <h-list-page class="RejectsStopList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>

        <h-search :title="h_i18n('5a6bde275a52b16fafea34e62cb728a2')">
          <h-input clearable v-model="searchData.stopCheckId" @change="changeNull(searchData.stopCheckId, 'stopCheckId')"></h-input>
        </h-search>

        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
            <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false" @input="() =>
                  searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                  @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
                  @focus="detailFocus('showMtlPlan')">
            </h-autocomplete>
            <h-detail width="400px" top="34px" left="0px">
              <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
                max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
                <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
                <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
              </el-table>
              <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                  padding-top: 3px;">
                <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('fb36f45f54ec9c9de745b566c6e60e25') }}</span>
              </div>
            </h-detail>
          </h-search>

          <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
            <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
            </h-input>
          </h-search>

          <h-search :title="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')">
            <h-input v-model="searchData.sybName" clearable @change="changeNull(searchData.sybName, 'sybName')">
            </h-input>
          </h-search>

          <h-search :title="h_i18n('ae3e3cb154d57b7238b0014ad9683c66')">
            <h-select v-model="searchData.stopStutas" clearable filterable @change="changeNull(searchData.stopStutas, 'stopStutas')">
              <h-option v-for="item in data.stopStutasList" :key="item.valueId" :label="item.valueName" :value="item.valueId">
              </h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('b6d0e97218a470eeff7a2bed42b44e21')">
            <h-select v-model="searchData.auditStatus" clearable filterable @change="changeNull(searchData.auditStatus, 'auditStatus')">
              <h-option v-for="item in data.auditStatusList" :key="item.valueId" :label="item.valueName" :value="item.valueId">
              </h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('cbdba878d17090b8feae391f103e1ad2')">
            <h-select v-model="searchData.questionType" clearable filterable @change="changeNull(searchData.questionType, 'questionType')">
              <h-option v-for="item in data.questionTypeList" :key="item.valueId" :label="item.valueName" :value="item.valueId">
              </h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('37769e25fffd760203c860702167cd26')">
            <h-select v-model="searchData.appealStatus" clearable filterable @change="changeNull(searchData.appealStatus, 'appealStatus')">
              <h-option :label="h_i18n('31b88d82c7738269292a70555719d18d')" value="自动认可"></h-option>
              <h-option :label="h_i18n('fcbda1a3b9a1f991de0b81f94ee7365c')" value="供方认可"></h-option>
              <h-option :label="h_i18n('5cb424765cb101866f47ca115605ce3b')" value="待审核"></h-option>
              <h-option :label="h_i18n('9109d5ff67cfd588c1d5265d160a958f')" value="待终判"></h-option>
              <h-option :label="h_i18n('db6e70ed7144c383e800dd36fe849cdf')" value="终判通过"></h-option>
              <h-option :label="h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')" value="终判不通过"></h-option>
            </h-select>
          </h-search>

          <h-search :title="h_i18n('55ebf36b676c9893d645d6447fe97824')">
            <h-date-picker @change="TimeChange(searchData.isrtDate, {start:'isrtDateBegin',end:'isrtDateEnd'})" v-model="searchData.isrtDate"
              type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
          </h-search>

          <h-search :title="h_i18n('05d6547b0261f659aabe09d0d60344b3')">
            <h-date-picker @change="TimeChange(searchData.stopCheckTime, {start:'stopCheckTimeBegin',end:'stopCheckTimeEnd'})" v-model="searchData.stopCheckTime"
              type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
          </h-search>

          <h-search :title="h_i18n('f6e1577e70d7b852d6395bab4f8902ca')">
            <h-date-picker @change="TimeChange(searchData.restoreDate, {start:'restoreDateBegin',end:'restoreDateEnd'})" v-model="searchData.restoreDate"
              type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
          </h-search>
          
          <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('0addf9d81daedc6979addd92d00e46c1')" :is-left="2" :is-right="2" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-if="item.code == 'mkhl_tjd_tjd_export'">
              <h-button type="primary" :loading="data.exportLoading" @click="excleBtn">
                <i class="iconfont icon-daochu"></i>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            </template>
          </template>
            <div style="display: flex;align-items: center;margin-left: 20px;color: #2164F5;font-size: 16px">{{ h_i18n('c5be7285cfbb8db86adacca60325a8d0') }}</div>
          <!-- <h-button type="primary" :loading="data.exportLoading" @click="backOldVersion" v-if="new Date() < 1711915508000">
            <history />
          切换旧版</h-button>
          <div v-if="new Date() < 1711915508000" class="dangerColor" style="display: flex;align-items: center;margin-left: 20px;font-size: 12px">
            备注：停检单新版试运行，老版本预计3月31号下线；新版使用过程中若有问题请及时反馈，紧急业务可优先切换旧版处理。
          </div> -->
          <div class="dangerColor" style="display: flex;align-items: center;margin-left: 20px;font-size: 12px">{{ h_i18n('21135ce9bd851afc61c126940f09ed84') }}</div>
          <div class="tipBox_yellow">
            <img src="@/assets/img/tips-icon.png" class="tip-img" />
              {{ h_i18n('A6097BCE7EA82BD1FE61475345862C1A') }}
          </div>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
        border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="stopCheckId" :label="h_i18n('5a6bde275a52b16fafea34e62cb728a2')" width="160">
          <template #default="{ row }">
            <span style="text-decoration: none;color:#2164F5; cursor: pointer;" @click="detailBtn(row)">{{ row.stopCheckId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stopStutasName" :label="h_i18n('ae3e3cb154d57b7238b0014ad9683c66')" min-width="130" class-name="btn_cell_style">
          <template #default="{ row }">
            <el-tag v-if="row.stopStutasName && row.stopStutasName.includes(h_i18n('cea0671a77281d4923d26111191e4fd8'))" type="success" size="small">{{row.stopStutasName}}</el-tag>
            <el-tag v-else-if="row.stopStutasName == h_i18n('c10f502eae7a1921c8be2cbdf21caec2')" type="warning" size="small">{{row.stopStutasName}}</el-tag>
            <el-tag v-else-if="row.stopStutasName == h_i18n('4f5a6b5e44df705921048a85680b1a26')" type="danger" size="small">{{row.stopStutasName}}</el-tag>
            <el-tag v-else-if="row.stopStutasName == h_i18n('b70e8e43e3deed10c24d7724f4e39efb')" size="small">{{row.stopStutasName}}</el-tag>
            <el-tag v-else-if="row.stopStutasName == h_i18n('8bc58efe05bfb5e7b83fd3ac9ba2c225')" type="info" size="small">{{row.stopStutasName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatusName" :label="h_i18n('b6d0e97218a470eeff7a2bed42b44e21')" width="190" class-name="btn_cell_style">
          <template #default="{ row }">
            <el-tag v-if="row.auditStatus === 1340" type="warning" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1343" type="warning" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1352" type="warning" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1353" type="warning" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1342" type="danger" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1345" type="danger" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1341" type="primary" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 1344" type="primary" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 3409" type="warning" size="extra-small">{{row.auditStatusName}}</el-tag>
            <el-tag v-else-if="row.auditStatus === 3410" type="danger" size="extra-small">{{row.auditStatusName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isRestore" :label="h_i18n('57187972b89fde3ceca4aeb7847fc8cd')" width="80">
          <template #default="{ row }">
            <span class="blueColor" v-if="row.isRestore == 'Y'">{{ h_i18n('b70e8e43e3deed10c24d7724f4e39efb') }}</span>
            <span class="dangerColor" v-if="row.isRestore == 'N'">{{ h_i18n('bd51532715200bf11b6437f0d7590a96') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200" class-name="textalignleft_style"></el-table-column>
        <el-table-column prop="questionTypeName" :label="h_i18n('cbdba878d17090b8feae391f103e1ad2')" width="150"></el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')" width="120"></el-table-column>
        <!-- <el-table-column prop="closeName" label="闭环人" width="90"></el-table-column> -->
        <!-- <el-table-column prop="isrtEmpName" label="编制" width="90"></el-table-column> -->
        <el-table-column prop="isrtDate" :label="h_i18n('55ebf36b676c9893d645d6447fe97824')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stopCheckTime" :label="h_i18n('05d6547b0261f659aabe09d0d60344b3')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.stopCheckTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="closeDate" :label="h_i18n('e4372d7b42c7d5899019c3160b56e1a4')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.closeDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="restoreDate" :label="h_i18n('f6e1577e70d7b852d6395bab4f8902ca')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.restoreDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stopTimes" :label="h_i18n('a490659b0cc49464ae2ca5348304abc3')" width="120"></el-table-column>
        <el-table-column prop="beforeRecheckDate" :label="h_i18n('dae79202f316da91602133e7c3a6a6b7')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.beforeRecheckDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="recheckDate" :label="h_i18n('650004574dad368e57b528a8d37b20a4')" width="100">
          <template #default="{ row }">
            <span>{{ time(row.recheckDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="recheckResult" :label="h_i18n('c6278ef07ae975b229e03b2205f2670b')" width="100">
          <template #default="{ row }">
            <span v-if="row.recheckResult == 'Y'" class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <span v-else-if="row.recheckResult == 'N'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="stopSourceName" :label="h_i18n('26ca20b161c33362d88eb0ba0bc90751')" width="100"></el-table-column>
        <el-table-column prop="appealStatus" :label="h_i18n('37769e25fffd760203c860702167cd26')" width="100"></el-table-column>
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" class-name="table_button_style" width="250">
          <template #default="{row}">
            <template v-if="new Date(row.isrtDate) < 1675872000000">
              <!-- <h-button type="" disabled>认可</h-button>
              &nbsp;
              <h-button type="" disabled>申诉</h-button> -->
            </template>
            <template v-else-if="!row.appealStatus">
              <h-button v-if="data.btnListOfSqm.some(item=>item.code === 'mkhl_tjd_tjd_RK')" type="primary" @click="approval(row)" :loading="data.approvalLoading">{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button v-if="data.btnListOfSqm.some(item=>item.code === 'mkhl_tjd_tjd_SS')" type="danger" @click="createAppeal(row)">{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
            <template v-else>
              <h-button v-if="data.btnListOfSqm.some(item=>item.code === 'mkhl_tjd_tjd_RK')" type="primary" disabled>{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button v-if="data.btnListOfSqm.some(item=>item.code === 'mkhl_tjd_tjd_SS')" type="danger" disabled>{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
            <!-- 整改 auditBtn -->
            <template v-if="data.btnListOfSqm.some(item=>item.code === 'mkhl_tjd_tjd_ZG') && row.isValid === 'Y'">
              &nbsp;
              <h-button type="primary" :disabled="(row.auditStatus !== 3409 && row.auditStatus !== 3410) || row.isValid === 'N'" @click="auditBtn(row)">{{ h_i18n('59c1d28ffbf075894cb2684f702476c5') }}</h-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="h_i18n('f630b9a4da10f81b7bb1c75bf6345558')" class-name="table_button_style">
          <template #default="{row}">
            <h-button type="warning" @click="openProcess(row)">{{ h_i18n('f630b9a4da10f81b7bb1c75bf6345558') }}</h-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.current" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>
    </h-table-card>

    <h-dialog :title="h_i18n('ae762b31e735d05f32b0f8aef726da64')" class="process_dialog_style" :show="data.dialogOfProcess" width="70%" @close="data.dialogOfProcess = false, data.processData = []">
      <el-table :data="data.processData.slice((data.processPageNo-1)*10,data.processPageNo*10)"
          v-loading="data.processLoading" border size="small" height="540">
          <el-table-column prop="role" :label="h_i18n('8402fcdd8d97edd86fb1bc69059db687')" min-width="100"></el-table-column>
          <!-- <el-table-column prop="createDisplayName" label="姓名" max-width="150"></el-table-column>
          <el-table-column prop="createUserName" label="工号" max-width="150"></el-table-column> -->
          <el-table-column prop="createDateTime" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170"></el-table-column>
          <el-table-column prop="flagVal" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="100"></el-table-column>
          <el-table-column prop="approveDetail" :label="h_i18n('a6396f13c260444d561afaa9407467be')" min-width="200"></el-table-column>
        </el-table>
        <el-pagination background @current-change="processCurrentChange" v-model:currentPage="data.processPageNo"
                     :page-size="10" layout="total, prev, pager, next,jumper" :total="data.processPageTotal" :hide-on-single-page="data.processPageTotal <= 10">
      </el-pagination>
    </h-dialog>

  </h-list-page>
</template>


<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()
  const searchData = reactive({
    mtlNo:'',
    supplyCode : '',
    current: 1,
    size: 10,
  })

  const data = reactive({
    dataOfTable:[],
    total: 0,
    keepalivestatus: 0,
    mtlLoading: false,
    tableLoading: false,
    exportLoading: false,
    rowListOfCheck:[],

    // 流程
    dialogOfProcess:false,
    processData:[],
    processLoading:false,
    processPageNo:1,
    processPageTotal:0,

    // 认可 申诉
    approvalId: "", //认可id
    approvalLoading:false,
    btnCodeList:[
      "mkhl_tjd_tjd_export",
    ],
    btnListOfSqm:[]
  })
    // 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_tjd_tjd_export":
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_tjd_tjd_export":
    return 
  }
}
/**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};
// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  MtlOver600: false,
  SupplyOver600: false,
  showSupplyPlan: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy.$http({
      method: "POST",
      url: "/base/basicData/searchMaterielList",
      headers: { "content-type": "application/json" },
      data: {
        mtlNo: searchData.mtlNo,
      },
      cancelToken: http.mtlSearchHttp.token,
    })
    .then((res) => {
      data.mtlNoList = res.data.data;
      if (data.mtlNoList.length >= 600) {
        plan.MtlOver600 = true;
        data.mtlLoading = false;
      } else {
        plan.MtlOver600 = false;
        data.mtlLoading = false;
      }
    }).catch((e) => { })
  }
};
// 两个模糊查询结束
/**
 * 打开流程 图表
 */
 const openProcess = (row) => {
  data.processLoading = true
  proxy.$http({
    url:'/base/rejectsStop/selectProcessNodeList?stopCheckId='+row.stopCheckId,
    method:'get',
  }).then(res=>{
    if(res.data.code == '200' && res.data.data){
      data.processData = res.data.data
      data.processPageTotal = res.data.data.length
      data.dialogOfProcess = true
    }else{
      data.processData = []
      data.processPageTotal = 0
      proxy.info(h_i18n('14638c3090ed989442ad2276b900401d'))
    }
  }).catch(err=>{
    data.processData = []
    data.processPageTotal = 0
  }).finally(()=>{
    data.processLoading = false
  })
}
// dialog table 翻页
const processCurrentChange = (v) => {
  data.processPageNo = v
}

// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}

// 认可 
const approval = (row) => {
  if(!row.stopCheckId){
    proxy.info(h_i18n('a9136d28a841943b5e954d9131a70835'))
    return
  }
  data.approvalId = row.stopCheckId
  // data.approvalLoading = true
  proxy.warning({title:h_i18n('900c70fa5f7dbc014e6f762d5e0e885c'),message:h_i18n('99652ba7c48d6bba558e3b2182e9c31a'),confirmButtonText:h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
  callback: (action) => {
    if(action == 'confirm'){
      proxy.$http({
        method: "post",
        url: `/base/RefusalAppeal/updateStop?stopId=${data.approvalId}&appealStatus=${encodeURI('供方认可')}&usercode=${data.supplyCode}&username=${data.trueName}`,
      }).then(res=>{
        console.log(res)
        if (res.data.code == '0' && res.data.data == h_i18n('330363dfc524cff2488f2ebde0500896') && res.data.msg == '成功') {
          proxy.success(res.data?.data)
          getInfo()
        } else {
          proxy.info(res.data?.data)
        }
      }).catch(err=>{
        proxy.error(err)
      }).finally(()=>{
        data.approvalId = ''
        // data.approvalLoading = false
      })
    }else{
      // data.approvalLoading = false
    }
  }
})
}

// 申诉
const createAppeal = (row) => {
  let userData = {
    supplyCode: data.supplyCode,
    supplyName: data.supplyName,
    // applyName: data.trueName,
    trueName: data.trueName,
  };
  proxy.$router.push({
    name: 'RejectsStopAppeal',
    query: {
      ...userData,
      stopCheckId:row.stopCheckId,
      dataFrom:"sqm",
    }
  })
}
/**
 * 查看详情
 */
 const detailBtn = (row) => {
  proxy.$router.push({
    name: "RejectsStopDetail",
    query: {
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      dataFrom:'sqm',
      kindType:'detail',
      stopCheckId:row.stopCheckId,
      sourceId:row.sourceId,
    }
  })
 }
/**
 * sqm整改
 */
 const auditBtn = (row) => {
  proxy.$router.push({
    name: "RejectsStopAudit",
    query: {
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      dataFrom:'sqm',
      kindType:'sqmAudit',
      stopCheckId:row.stopCheckId,
      sourceId:row.sourceId,
    }
  })
 }
// 查询
const getInfo = (flag) => {
  if (true == flag) {
    searchData.current = 1;
  }
  data.tableLoading = true;
  proxy.$http({
    url: "/base/rejectsStop/rejectsStopList",
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo || undefined,
      supplyCode: searchData.supplyCode || undefined,
      queryFlag:"sqm",
      name:undefined,
      nickName:undefined,
      isrtDate:undefined,
      stopCheckTime:undefined,
      restoreDate:undefined,
      appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
      auditStatus: searchData.auditStatus ? searchData.auditStatus.toString().split(",") : undefined,
      questionType: searchData.questionType ? searchData.questionType.toString().split(",") : undefined,
      stopStutas: searchData.stopStutas ? searchData.stopStutas.toString().split(",") : undefined,
    }
  }).then(res=>{
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  })
}

// 导出
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning(
      { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
      {
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { },
      }
    );
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('fe0be8de33bd8dda68ddc037da08bdbf'));
  proxy.httpFile(
    {
      method: "post",
      url: "/base/rejectsStop/rejects8dListExportSqm",
      data: {
        ...searchData,
        mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
        isrtDate:undefined,
        stopCheckTime:undefined,
        restoreDate:undefined,
        size: undefined,
        current: undefined,
        queryFlag:'sqm',
        appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
        auditStatus: searchData.auditStatus ? searchData.auditStatus.toString().split(",") : undefined,
        questionType: searchData.questionType ? searchData.questionType.toString().split(",") : undefined,
        stopStutas: searchData.stopStutas ? searchData.stopStutas.toString().split(",") : undefined,
      },
    },
    h_i18n('5790266c2afb64c88b3d7d537d57a471')
  ).then(res=>{
    data.exportLoading = false;
  }).catch(err=>{
    data.exportLoading = false;
    proxy.closeLoading()
  })
}

// 查询属性 /basicData/searchByValueTypeId
const getValueType = (id) => {
  proxy.$http({
    url: "/base/basicData/listBaseValues?valueTypeId=" + id,
    method: "get",
  }).then(res=>{
    if(res.data.code == 200 && res.data.data.length > 1){
      id == 54 && (data.stopStutasList = res.data.data)
      id == 56 && (data.auditStatusList = res.data.data)
      id == 53 && (data.questionTypeList = res.data.data)
    }
  }).catch(err=>{

  }).finally(()=>{

  })
}
// 设置默认查询时间 - 编制日期
const setDate = () => {
  searchData.isrtDate = [new Date().getTime() - 24 * 30 * 60 * 60 * 1000 , new Date()]
  searchData.isrtDateBegin = proxy.time(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)
  searchData.isrtDateEnd = proxy.time(new Date())
}
// 切换旧版
const backOldVersion = () => {
  if (process.env.NODE_ENV != 'production') {
    window.open("http://sqm-test.qd-huangdao-test.haier.net/report/rejects_stop_haier_index1?vcode="+ data.supplyCode)
  }else{
    window.open("https://sqm.haier.net/report/rejects_stop_haier_index1?vcode="+ data.supplyCode)
  }
}
onBeforeMount(()=>{
  getValueType(54) // 停检状态54
  getValueType(56) // 审核状态56
  getValueType(53) // 问题类别53
})
onMounted(() => {
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    if (route.query) {
      data.supplyCode = route.query.supplyCode;
      searchData.supplyCode = route.query.supplyCode;
      data.supplyName = route.query.supplyName;
      data.trueName = route.query.trueName;
      data.roleCode = route.query.roleCode;
      data.userName = route.query.userName;
    }
    if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }else{
    data.btnListOfSqm = [{code:'mkhl_tjd_tjd_export',name:'导出'}]
  }
    setDate()
    getInfo();
  })
  onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus ++ 
  } else {
    proxy.postThisPageHeight();
    console.log("操作完之后打开");
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    getInfo()
  }
})
onDeactivated(() => {
})
</script>

<style lang="scss">
.RejectsStopList_style{
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
  .btn_cell_style{
    padding: 0px !important;
  }
  .table_button_style{
    padding: 7px 0 !important;
  }
}
.planHidden{
  display: none;
}
.process_dialog_style{
  .haier-dialog{
    top:100px;
  }
}
</style>